module.exports = __webpack_public_path__ + "static/media/sorrow-video.7a6f7daf.mov";